export default __webpack_public_path__ + "static/media/banner_1.98c53579.png";